import { initFlightSearchForms } from '../lib/flight-search-form.js';
import { initFaq } from '../lib/faq.js';

function init() {
  initFlightSearchForms();
  initFaq();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
